<i class="{{ style }} fa-{{ name }}"></i>
